<vb-loading-spinner *ngIf="status.isLoading" [block]="true" [size]="'medium'">
</vb-loading-spinner>

<vb-ui-bar-chart *ngIf="status.active" class="height-full" [categoryField]="'key'" [valueField]="'attendeesCount'" [data]="data" [isDateAxis]="true" [valueAxisTitleLabel]="'Attendees' | translate" [hideLegend]="true">
</vb-ui-bar-chart>
